import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?worker&url'

GlobalWorkerOptions.workerSrc = pdfjsWorker

const MAXIMUM_SIZE = 4096

export async function convert(file: ArrayBuffer): Promise<ArrayBuffer> {
  const pdf = await getDocument(file).promise
  const page = await pdf.getPage(1)
  const scale = 2
  const viewport = page.getViewport({ scale })

  const width = viewport.width
  const height = viewport.height
  let mulFactor = 2

  while (Math.round(width * mulFactor) > MAXIMUM_SIZE || Math.round(height * mulFactor) > MAXIMUM_SIZE) {
    mulFactor /= 2
  }

  let canvas: OffscreenCanvas
  let context: OffscreenCanvasRenderingContext2D

  let lastBlobError: unknown
  let attempts = 0

  do {
    const canvasWidth = Math.max(1, Math.round(width * mulFactor))
    const canvasHeight = Math.max(1, Math.round(height * mulFactor))

    canvas = new OffscreenCanvas(canvasWidth, canvasHeight)
    context = canvas.getContext('2d')!

    try {
      await canvas.convertToBlob()
      lastBlobError = undefined
      break
    } catch (err) {
      lastBlobError = err
      mulFactor /= 2
    }

    attempts++
  } while (attempts < 10)

  if (lastBlobError) throw lastBlobError

  const transform = [mulFactor, 0, 0, mulFactor, 0, 0]

  // @ts-expect-error this is an offscreen context
  await page.render({ canvasContext: context, transform, viewport }).promise

  return canvas.convertToBlob().then(blob => blob.arrayBuffer())
}
